import React, { useEffect, useRef } from "react";

// Plays only while on screen, and never for reduced-motion users (they get the poster).
const ScreenVideo = ({ src, poster }) => {
  const ref = useRef(null);

  useEffect(() => {
    const video = ref.current;
    if (!video || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) video.play().catch(() => {});
      else video.pause();
    });
    observer.observe(video);
    return () => observer.disconnect();
  }, []);

  return <video ref={ref} src={src} poster={poster} muted loop playsInline preload="none" aria-hidden="true" />;
};

const Screen = ({ image, video }) => (
  <div className="device-screen">
    {video ? (
      <ScreenVideo src={video} poster={image} />
    ) : (
      <img src={image} alt="" loading="lazy" decoding="async" draggable="false" />
    )}
  </div>
);

export const DeviceMockup = ({ device = "laptop", image, video }) => (
  <figure className={`device-stage device-stage--${device}`}>
    {device === "phone" ? (
      <div className="device-phone">
        <Screen image={image} video={video} />
        <span className="device-phone-island" aria-hidden="true" />
      </div>
    ) : (
      <div className="device-laptop">
        <div className="device-laptop-lid">
          <Screen image={image} video={video} />
        </div>
        <div className="device-laptop-base" aria-hidden="true" />
      </div>
    )}
  </figure>
);

export default DeviceMockup;
